import createReactClass from 'create-react-class';
import React from 'react';

export const InformationRadiatorRowView = createReactClass({

    render: function () {
        var message = this.props.message;

        switch (message.type) {
            case 'info':
                var style = "informationRadiatorInfoItem";
                break;
            case 'warning':
                var style = "informationRadiatorWarningItem";
                break;
            default:
                //assume error I guess
                var style = "informationRadiatorErrorItem";
        }

        //display new lines in the messages
        var messageParts = message.message ? message.message.split('\\n') : [];
        message = messageParts.map(function (m, i) {
            return (<div key={i}>{m}</div>);
        });


        return (
            <li htmlFor={message.field} className={style}>
                {message}
            </li>
        );
    },
});
